module.exports = __webpack_public_path__ + "img/type-8-1.9628d07f.png";